// extracted by mini-css-extract-plugin
export var ArticleCard = "BlockSearchResult-module--ArticleCard--7e6a6";
export var articleContent = "BlockSearchResult-module--articleContent--428b9";
export var buttonTag = "BlockSearchResult-module--buttonTag--4c2c1";
export var capitalize = "BlockSearchResult-module--capitalize--1130b";
export var date = "BlockSearchResult-module--date--c6e4b";
export var dateMobile = "BlockSearchResult-module--dateMobile--32485";
export var fs14 = "BlockSearchResult-module--fs-14--f5508";
export var fs16 = "BlockSearchResult-module--fs-16--a3abb";
export var fs20 = "BlockSearchResult-module--fs-20--5e2f6";
export var fs24 = "BlockSearchResult-module--fs-24--0efd9";
export var fs32 = "BlockSearchResult-module--fs-32--844e8";
export var fs40 = "BlockSearchResult-module--fs-40--59803";
export var fsItalic = "BlockSearchResult-module--fs-italic--20a28";
export var fsLg = "BlockSearchResult-module--fs-lg--ff5a4";
export var fsMd = "BlockSearchResult-module--fs-md--c7bd2";
export var fsNormal = "BlockSearchResult-module--fs-normal--a817e";
export var fsSm = "BlockSearchResult-module--fs-sm--aed92";
export var fsXl = "BlockSearchResult-module--fs-xl--9d15b";
export var fsXs = "BlockSearchResult-module--fs-xs--45d99";
export var fsXxl = "BlockSearchResult-module--fs-xxl--6b3a4";
export var fsXxs = "BlockSearchResult-module--fs-xxs--d24af";
export var fwBold = "BlockSearchResult-module--fw-bold--eed6a";
export var fwMedium = "BlockSearchResult-module--fw-medium--834e5";
export var fwNormal = "BlockSearchResult-module--fw-normal--86134";
export var gotham_bold = "BlockSearchResult-module--gotham_bold--e62e8";
export var gotham_bold_italic = "BlockSearchResult-module--gotham_bold_italic--304f7";
export var gotham_book = "BlockSearchResult-module--gotham_book--39ee7";
export var gotham_book_italic = "BlockSearchResult-module--gotham_book_italic--120c7";
export var icon = "BlockSearchResult-module--icon--c32e4";
export var iconContainer = "BlockSearchResult-module--iconContainer--8164b";
export var img = "BlockSearchResult-module--img--30fc8";
export var lowercase = "BlockSearchResult-module--lowercase--ab2c1";
export var seeMoreButton = "BlockSearchResult-module--seeMoreButton--785a8";
export var tag = "BlockSearchResult-module--tag--0a3df";
export var tagMobile = "BlockSearchResult-module--tagMobile--8dbf7";
export var tagsContainer = "BlockSearchResult-module--tagsContainer--14c5d";
export var tagsMobile = "BlockSearchResult-module--tagsMobile--4d8bc";
export var tagsSwiper = "BlockSearchResult-module--tagsSwiper--d3a56";
export var uppercase = "BlockSearchResult-module--uppercase--64586";